import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, IUserViewState } from '../modules/userView'

type IComponentProps = IUserViewState &
  RouteComponentProps<{ id: string }> &
  typeof actionCreators

class UserPermissions extends React.PureComponent<IComponentProps> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>{this._renderPermissions()}</div>
      </div>
    )
  }

  private _renderPermissions() {
    if (!this.props.item.user) {
      return null
    }

    const permissions = Object.keys(
      this.props.item.user.permissions.specialPermissions,
    ).map((item: any) => {
      let statusIcon: [IconPrefix, IconName] = ['fas', 'times']
      let iconColor = 'red'

      if (
        this.props.item.user &&
        this.props.item.user.permissions.specialPermissions[item] === true
      ) {
        statusIcon = ['fas', 'check']
        iconColor = 'green'
      }
      return (
        <div key={item} className='d-flex flex-row flex-wrap mt-2'>
          <div className='mr-2' style={{ color: iconColor }}>
            <FontAwesomeIcon fixedWidth icon={statusIcon} />
          </div>
          {humanize(item)}
        </div>
      )
    })

    return <div>{permissions}</div>
  }
}

export default withRouter(UserPermissions)
